import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router";
import apiCall from "../../../helpers/apifactory";
import TrackInfoComponent from "../../common/TrackInfoComponent";
import { ServicesProvider } from "../../common/AlertService";
import { useNavigate } from "react-router-dom";

const Track = (data) => {
  let navigate = useNavigate();

  useEffect(() => {
    let current_page = window.location.href.split("/").at(-1);
    setTimeout(() => {
      document
        .getElementById(`${current_page}`)
        ?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, 100);
  });
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
      top > header_height && window_width > 1024
        ? document.querySelector("a").classList.add("fixed-header-desktop")
        : document.querySelector("a").classList.remove("fixed-header-desktop");
    },
    false
  );
  window.addEventListener(
    "scroll",
    function (event) {
      let top = this.scrollY,
        window_width = window.innerWidth,
        header_height = document.querySelector("header").style.height + 100;
      top > header_height && window_width > 1024
        ? document.querySelector("nav").classList.add("fixed-header-desktop")
        : document
            .querySelector("nav")
            .classList.remove("fixed-header-desktop");
      // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    },
    false
  );

  // const trackNumber = useParams()["*"];
  const trackNumber = useParams()["*"];
  const [trackData, setTrackData] = useState();
  const [inputTrack, setInputTrack] = useState();
  const { alertMessage, loaderShow } = useContext(ServicesProvider);
  const [token, settoken] = useState(null);

  // useEffect(() => {
  //   // console.log("------>");
  //   calltrackApi(trackNumber);
  //   apiCall.middlewareAuthToken().then((token) => {
  //     const {
  //       data: { result: accessToken },
  //     } = token;
  //     // console.log('000000000000000000', accessToken?.accessToken)
  //     settoken(accessToken.accessToken);
  //     // console.log(accessToken.accessToken)
  //     // settoken("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjpbIk5vdGlmaWNhdGlvbiIsIlRyYWNrIiwiVFRDIiwiQ0xTIl0sImNsaWVudGlkIjoiMjE1NjA4OTg4IiwiYXVkIjpbImNvbm5lY3QudGNzY291cmllci5jb20iLCJjb25uZWN0LnRjc2NvdXJpZXIuY29tIl0sImlzcyI6ImNvbm5lY3QudGNzY291cmllci5jb20iLCJqdGkiOiIzZWU0ZTU1MC0xY2E5LTQyY2QtODM1NS1kNmE5ZWJlZGVhY2MiLCJuYmYiOjE2NzY1MzMxMjYsImV4cCI6MTc2MjkzMzEyNiwiaWF0IjoxNjc2NTMzMTI2fQ.gyF3BhUUC-2kRQST_UnZkttJtwGVW2li0_5fdpTvK2s");
  //     // console.log("------", accessToken.accessToken);

  //   });

  // }, []);

  useEffect(() => {
    // if (trackNumber && token) {
    calltrackApi(trackNumber);
    // }
  }, [token]);

  const calltrackApi = async (tracknum) => {
    loaderShow();
    const header = {
      Authorization: `Bearer ${token}`,
    };
    // console.log(header);

    apiCall
      // .trackApiNew(tracknum)
      .trackApiNew(tracknum)
      .then((d) => {
        // console.log("============>>>>", d?.data?.message);
        // return;
        // const { message } = d.data;

        // console.log(d.data);

        // if (d.data.returnResult.message == "SUCCESS") {
        if (d?.data?.responseData?.message === "SUCCESS") {
          // console.log("============>>>>", d?.data);
          // const data = Data[0];
          // alert(JSON.stringify(d.data.TrackDetailReply))
          // setTrackData(d.data.TrackDetailReply);
          setTrackData(d?.data?.responseData);
        } else {
        }
        loaderShow(false);
      })
      .catch((error) => {
        alertMessage(error, "error");
        console.log(error);
      });
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const trackNo = inputTrack;
      if (!trackNo) {
        console.log(trackNo);
        return;
      }
      calltrackApi(trackNo);
      navigate("/");
      navigate(`/track/${trackNo}`);
    }
  };

  const onSubmit = (e) => {
    // if (e.key === 'Enter') {
    const trackNo = inputTrack;
    if (!trackNo) {
      console.log(trackNo);
      return;
    }
    calltrackApi(trackNo);
    navigate("/");
    navigate(`/track/${trackNo}`);
    // };
  };

  const [tickerKey, setTickerKey] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTickerKey((prevKey) => prevKey + 1);
    }, 20000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      {/* <div className="ticker-wrapper" key={tickerKey}>
        <div className="text-update">
          <p>
            Some deliveries may be delayed due to foggy weather.
            <span style={{ fontSize: "1rem", margin: "0 2%" }}>
              موسم دھند آلود ہونے کی وجہ سے کچھ ترسیلات میں تاخیر ہو سکتی ہے۔
            </span>
          </p>
        </div>
      </div> */}
      <div className="ticker-wrapper  overflow-hidden">
        <div className="ticker">
          <div className="ticker__item">
            <p className="font-bold text-[12px]  ">
              Scammers are sending fake SMS & WhatsApp messages posing as
              representatives of delivery services. Please do not click on any
              such links. TCS SMS short code is 8591 & we never ask for payment
              via SMS or WhatsApp
              {/* <span style={{ fontSize: "1rem", margin: "0 2%" }}>
                گہری دھند نے کئی علاقوں کو اپنی لپیٹ میں لے لیا ہے جس کی وجہ سے
                حدِ نظرمیں مشکلات پیدا ہو رہی ہیں۔ یہ دھند ہمیں پریشان کر سکتی
                ہے لیکن یہ ہمیں روک نہیں سکتی! آپ کی خدمت کے لیے ہمارا عزم پختہ
                ہے اور ہم دن رات محنت کر رہے ہیں تاکہ آپ کی شپمنٹس بحفاظت اپنی
                منزل تک پہنچ سکیں۔ ٹی سی ایس کو منتخب کرنے کا شکریہ۔
              </span> */}
            </p>
          </div>
        </div>
      </div>
      <img src="/image.jpg" alt="" className="w-full" />
      {/* <!-- Form --> */}
      <div className="my-8 mb-16">
        <div className="text-center">
          <h2 className="text-3xl font-semibold">Track Your Shipment</h2>
          <p className="lg:text-center">
            Enter any combination of TCS tracking Reference number.
          </p>
        </div>
        <div className="flex justify-center mt-2">
          <div className="flex  justify-center items-center">
            <input
              onChange={(e) => {
                setInputTrack(e.target.value);
              }}
              onKeyDown={handleKeyDown}
              type="number"
              placeholder="Tracking Number"
              className="p-3 md:w-[27rem] sm:w-[20rem] w-[10rem] focus:outline-none opacity-75 rounded-l-sm border"
            />
            <button
              onClick={onSubmit}
              type="button"
              className="bg-[#D40511] text-white p-[13px]  sm:w-[10rem] w-[9rem] rounded-r-sm transition-all duration-500 gradientbg"
            >
              Track Shipment
            </button>
          </div>
        </div>
      </div>

      {/* {trackData &&
      trackData.trackinfo != null &&
      trackData.deliveryinfo != null &&
      trackData.trackinfo != null ? (
        <TrackInfoComponent value={trackData} />
      ) : trackData === null ? (
        <div className="flex justify-center items-center mb-[8rem]">
          <div className="w-[70rem]  shadow-card p-8">
            <div className="flex gap-4">
              <h2>No Record Found</h2>
            </div>
          </div>
        </div>
      ) : (
        <h2>No Record Found</h2>
      )}  */}

      {trackData ? (
        //&&
        //trackData.p_shipmentinfo != null &&
        //trackData.p_deliveryinfo != null &&
        //trackData.p_shipmentinfo != null
        <TrackInfoComponent value={trackData} />
      ) : trackData === null ? (
        <div className="flex justify-center items-center mb-[8rem]">
          <div className="w-[70rem]  shadow-card sm:p-8 p-3">
            <div className="flex gap-4">
              <h2>No Record Found</h2>
            </div>
          </div>
        </div>
      ) : (
        // <h2>No Record Found</h2>
        <div className="flex justify-center items-center mb-[8rem]">
          <div className="w-[70rem]  shadow-card sm:p-8 p-3">
            <div className="flex gap-4">
              <h2>No Record Found</h2>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Track;
